import React, { useEffect } from "react";

// Components
import ServerUnreachable from "COMPONENTS/ServerUnreachable/ServerUnreachable";

const ServerUnreachableContainer = (props) => {
  useEffect(() => {
    // Prevent you from going back using the browser's back button.
    history.pushState(null, null, location.href);
    window.onpopstate = function (event) {
      history.go(1);
    };
  }, []);

  return (
    <ServerUnreachable/>
  );
};

export default ServerUnreachableContainer;
